<ng-container *ngIf="isAdsOn" [ngTemplateOutlet]="ads"></ng-container>
<div [ngSwitch]="menu.shape" class="page" [ngStyle]="{'background': menu.color, 'background-image': 'url(' + menu.background + ')'}">
  <!-- Menu tipo PDF -->
  <ng-container *ngSwitchCase="TYPES_MENU.pdf">
    <app-sidemenu [restaurant]="restaurant" [menu]="menu" [isShowButton]="isSticky" *ngIf="isVisibleSideMenu()"></app-sidemenu>
    <ng-container *ngIf="isAdsOn" [ngTemplateOutlet]="ads"></ng-container>
    <div class="row">
      <div class="col-12" [ngStyle]="{'background': menu.color, 'background-image': 'url(' + menu.background + ')'}">
        <app-menu-pdf [menu]="menu"></app-menu-pdf>
      </div>
    </div>
    <app-footer *ngIf="footer && !isAdsOn" [menu]="menu" [showForm]="true" [restaurant]="restaurant" class="animate__animated fadeIn animate__delay-1s footer">
    </app-footer>
  </ng-container>
  <!-- Menus de tipo botones, scroll, buttonsAndTabs o tabs -->
  <ng-container *ngSwitchDefault>
    <div *ngIf="restaurant.services !== 'X'">
      <!-- Menu lateral -->
      <app-sidemenu [restaurant]="restaurant" [menu]="menu" [isShowButton]="isSticky" *ngIf="isVisibleSideMenu()"></app-sidemenu>

      <!-- Menus con imagenes -->
      <div *ngIf="menu.sections && !isAdsOn && (isMenuImages())" class="body animate__animated fadeIn">
        <app-menu-images [menu]="menu"></app-menu-images>
      </div>
      <!-- Menus interactivos -->
      <div *ngIf="menu && (!isMenuImages())" class="body backgrounds" id="list" style="overflow: auto;" (click)="setShowMenu()"
        [ngStyle]="{'background': menu.color, 'background-image': 'url(' + menu?.background + ')' }">
        <!-- Menu del restaurante -->
        <div class="body animate__animated fadeIn animate__delay-1s">
          <div class="header">
            <!-- Boton de idioma -->
            <div class="position-absolute mt-2 mr-2 buttonClose animate__animated animate__delay-2s bounceIn" *ngIf="!isAdsOn">
              <button class="btn btn-icon p-2" [ngStyle]="{'background': menu.color,'color': menu.colorText,'border-color': menu.color}" type="button" (click)="selectLanguage()"
                *ngIf="language? 'ES':'EN'">
                <i class="fas fa-globe-americas m--1" [ngClass]="{'fa-flag': language == 'ES', 'fa-flag-usa' : language == 'EN' }"></i>
                <span class="btn-inner--text">{{ language }}</span>
              </button>
            </div>
            <!-- Cabezote del menu -->
            <img [src]="menu?.photo" alt="" class="coverPage">
          </div>

          <!-- Menu en tabs -->
          <div class="row" *ngIf="(menu.shape === TYPES_MENU.tabs || !menu.shape)">
            <div class="col-12">
              <mat-tab-group class="backgrounds pb-7" scrollToCenter animationDuration="9ms" [(selectedIndex)]="tabIndexSelected" [ngClass]="{'sticky' : isSticky}"
                (selectedIndexChange)="tabChange($event)" [ngStyle]="{'background': menu.color, 'background-image': 'url(' + menu.background + ')'}">
                <mat-tab *ngFor="let tab of menu.sections | filter:'type': [TYPE_SECTIONS.separator]; let index = index;" [label]="language === 'ES'? tab.name: tab.nameEn">
                  <!-- Secciones -->
                  <div class="row body justify-content-center backgrounds" [ngStyle]="{'background': 'transparent'}">
                    <!-- Items de secciones con foto en columnas -->
                    <app-item-image [section]="tab" [menu]="menu" class="w-100"
                      *ngIf="menu.productsInColum && (tab.type === TYPE_SECTIONS.productsMenu || tab.type === TYPE_SECTIONS.productsOnlyPhoto)">
                    </app-item-image>
                    <!-- Items de secciones con foto 1 a 1 -->
                    <app-item [items]="tab.items" [menu]="menu"
                      *ngIf="!menu.productsInColum && (tab.type === TYPE_SECTIONS.productsMenu || tab.type === TYPE_SECTIONS.productsOnlyPhoto)">
                    </app-item>

                    <!-- Items de secciones con o sin logo en modo listado -->
                    <app-item-list *ngIf="tab.type === TYPE_SECTIONS.productList" [section]="tab" [menu]="menu" class="w-100">
                    </app-item-list>

                    <!-- Items de secciones en modo listado simple -->
                    <app-item-simple-list *ngIf="tab.type === TYPE_SECTIONS.productSimpleList" [section]="tab" [menu]="menu" class="w-100">
                    </app-item-simple-list>

                    <!-- Items de secciones de bebidas alcoholicas -->
                    <app-item-drinks *ngIf="tab.type === TYPE_SECTIONS.drinks || tab.type === TYPE_SECTIONS.wines" [section]="tab" [menu]="menu" class="w-100">
                    </app-item-drinks>

                    <!-- Items de secciones de bebidas alcoholicas -->
                    <app-item-drink-midle *ngIf="tab.type === TYPE_SECTIONS.drinks_midle" [section]="tab" [menu]="menu" class="w-100">
                    </app-item-drink-midle>

                    <!-- Items de secciones de galeria de imagenes -->
                    <app-item-gallery [section]="tab" *ngIf="tab.type === TYPE_SECTIONS.gallery"></app-item-gallery>
                    <!-- Items de secciones de galeria de videos -->
                    <app-item-video [section]="tab" *ngIf="tab.type === TYPE_SECTIONS.videos">

                    </app-item-video>
                    <!-- Items de secciones de adiciones -->
                    <app-item-list-additions *ngIf="menu.sections[index + 1]?.type === TYPE_SECTIONS.additions" [section]="menu.sections[index + 1]" [menu]="menu" class="w-100">
                    </app-item-list-additions>
                  </div>
                  <!-- Descripcion de la seccion -->
                  <div class="justify-content-center text-center d-flex text-center p-2" *ngIf="tab.description">
                    <p [ngStyle]="{'color': menu.colorText}" class="mb-4 {{menu.fontText}} font-weight-bold" *ngIf="language === 'ES'" [innerHTML]="tab.description">
                    </p>
                    <p [ngStyle]="{'color': menu.colorText}" class="mb-4 {{menu.fontText}} font-weight-bold" *ngIf="language === 'EN'" [innerHTML]="tab.description">
                    </p>
                  </div>
                  <div class="row">
                    <div class="col-12" *ngIf="tab.photo">
                      <img [src]="noImage" [alt]="isInViewport(tab)" [id]="tab.name" class="img-fluid" style="width: 100%;">
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
          <!-- Menu en infiniti scroll -->
          <div class="row p-2 filterSectionBackground" [ngStyle]="{'background': menu.color, 'background-image': 'url(' + menu.background + ')'}"
            [ngClass]="{'stikyFilter' : isSticky}" *ngIf="menu.shape === TYPES_MENU.scroll &&  menu.sections.length > 2">
            <div class="col-12" *ngIf="menu.sections.length > 1">
              <mat-form-field appearance="outline" class="w-100 section-select" [style.--section-accent]="menu.colorText">
                <mat-label>{{ language === 'ES'? 'Secciones': 'Sections' }}</mat-label>
                <mat-select (selectionChange)="filterSection($event.value.name)" hideSingleSelectionIndicator>
                  <mat-option [value]="section" *ngFor="let section of menu.sections | filter:'type': [TYPE_SECTIONS.gallery, TYPE_SECTIONS.additions]">
                    <div *ngIf="language === 'ES'">
                      {{ section.name | titlecase }}
                    </div>
                    <div *ngIf="language === 'EN'">
                      {{ section.nameEn | titlecase }}
                    </div>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <app-menu-infiniti-scroll *ngIf="menu.shape === TYPES_MENU.scroll" [menu]="menu"></app-menu-infiniti-scroll>
          <!-- Menu en botones por seccion -->
          <div class="row" *ngIf="menu.shape === TYPES_MENU.buttons">
            <div class="col-12">
              <app-menu-list-buttons [menu]="menu"></app-menu-list-buttons>
            </div>
          </div>

        </div>
      </div>

      <!-- Linea divisora entre productos -->
      <ng-template #line>
        <div class="row justify-content-center mt-3">
          <div class="col-9">
            <hr [ngStyle]="{'background': menu.colorText}">
          </div>
        </div>
      </ng-template>

      <!-- <Pide de pagina con las redes sociales -->
      <app-footer *ngIf="footer && !isAdsOn" [menu]="menu" [showForm]="true" [restaurant]="restaurant" class="animate__animated fadeIn animate__delay-1s footer">
      </app-footer>

      <!-- Alerta para visualizar el formulario de subscripcion -->
      <!-- <app-alert *ngIf="alert" [text]="alertMessage"></app-alert> -->

    </div>
  </ng-container>
</div>


<ng-template #ads>
  <!-- Publicidad -->
  <div class="animate__animated fadeIn animate__delay-1s position-absolute top">
    <app-ads (close)="adsOff($event)" [id]="id" [isHomeAd]="false"></app-ads>
  </div>
</ng-template>